import { QrCodeScannerRounded } from '@mui/icons-material';
import { Alert, Box, Grid, IconButton } from '@mui/material';
import { isEmpty } from 'lodash';
import React, { Component } from 'react';
import Creatable from '../../common/Creatable';
import Dialog from '../../common/Dialog';
import ScanQrCodeSearch from '../Equipements/Forms/ScanQrCodeSearch';


class OtherActionsSpendingDemand extends Component {
    state = { 
        eType: ""
    }
    componentDidMount = () => {
        window.scrollTo(0, 0);
        if(isEmpty(this.props.EQUIPEMENTS) ){
            this.props.fetchEquipements()
        }
        if(isEmpty(this.props.VEHICULES) ){
            this.props.fetchVehicules()
        }
        
    }
    openScanner = (eType) => {
        this.setState({
            eType,
            openScan: true
        })
    }
    render() {
        const { EQUIPEMENTS, VEHICULES } = this.props;
        return (
            <Dialog
                maxWidth="xs"
                close={this.props.handleClose}
                title="Éléments liés"
                submitAction={this.props.handleClose}
            >
                {this.state.openScan &&
                    <ScanQrCodeSearch 
                        handleClose={()=> this.setState({ openScan: false })}
                        title="Scanner un équipement"
                        VEHICULES={this.props.VEHICULES}
                        EQUIPEMENTS={this.props.EQUIPEMENTS}
                        equipement_type={this.state.eType}
                        setEquipement={(option) => this.props.handleChangeSelect(option, `spending_${this.state.eType}`)}
                    />
                }
                
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        {!isEmpty(EQUIPEMENTS) ? 
                            <Box style={{display:"flex"}}>
                                <Creatable
                                    label="Equipement"
                                    error={this.props.errors.spending_equipement}
                                    id="spending_equipement"
                                    labelWidth={100} 
                                    options={Object.values(EQUIPEMENTS).map( item => ({
                                        label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                        value: item.equipement_id,
                                    }))}
                                    value={this.props.spending_equipementDisplay}
                                    onChange={(option) => this.props.handleChangeSelect(option, "spending_equipement")}
                                />
                                <IconButton onClick={() => this.openScanner("equipement")} color="primary">
                                    <QrCodeScannerRounded />
                                </IconButton>

                            </Box>
                            :
                            <Alert severity="warning">Aucun équipement disponible</Alert>
                        }
                    </Grid>
                    <Grid item xs={12}>
                        {!isEmpty(VEHICULES) ? 
                            <Box style={{display:"flex"}}>
                                <Creatable
                                    label="Vehicule"
                                    error={this.props.errors.spending_vehicule}
                                    id="spending_vehicule"
                                    labelWidth={100} 
                                    options={Object.values(VEHICULES).map( item => ({
                                        label: `${item.equipement_ref.toUpperCase()} | ${item.equipement_name}`,
                                        value: item.equipement_id,
                                    }))}
                                    value={this.props.spending_vehiculeDisplay}
                                    onChange={(option) => this.props.handleChangeSelect(option, "spending_vehicule")}
                                />
                                <IconButton onClick={() => this.openScanner("vehicule")} color="primary">
                                    <QrCodeScannerRounded />
                                </IconButton>

                            </Box>
                            :
                            <Alert severity="warning">Aucun équipement disponible</Alert>
                        }
                    </Grid>
                </Grid>
            </Dialog>
        );
    }
}

export default OtherActionsSpendingDemand;